import { render, staticRenderFns } from "./Ace.component.vue?vue&type=template&id=2e9a6f2c&scoped=true&"
import script from "./Ace.component.vue?vue&type=script&lang=js&"
export * from "./Ace.component.vue?vue&type=script&lang=js&"
import style0 from "./Ace.component.vue?vue&type=style&index=0&id=2e9a6f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a6f2c",
  null
  
)

export default component.exports